import { defineComponent as _defineComponent } from 'vue'
import { lazyImageLabel, useLazyImage } from '@/features/ui/composables/useLazyImage';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProviderIconSquare',
  props: {
    provider: { default: () => ({
			icon: 'https://static.justwatch.com/static/compile_jw/assets/jw-icon-badge.png',
			clearName: 'JustWatch',
		}) },
    loading: { default: 'lazy' },
    size: { default: 'icon' }
  },
  setup(__props: any) {

const props = __props as { provider: {
			icon: string;
			clearName: string;
		}, loading: 'lazy' | 'eager', size: 'icon' | 'small' };



const { _el, isVisible } = useLazyImage(props.loading !== 'eager');

function iconUrl(format: 'avif' | 'webp' | 'jpeg') {
	const prefix = props.provider.icon.startsWith('/') ? JW_CONFIG.IMAGESCALER_URL : '';
	return (
		prefix +
		props.provider.icon.replace('{profile}', props.size === 'icon' ? 's100' : 's40').replace('{format}', format)
	);
}

return { __sfc: true,props, _el, isVisible, iconUrl, lazyImageLabel }
}

})